import React from "react";
import Header from "../Header/Header";
import Footer from "../../Components/Footer/Footer";
import { Link } from "react-router-dom";

const ShippingPolicy = () => {
	return (
		<>
			<Header />
			<div className="min-h-screen bg-gray-50 px-4 py-10 sm:px-6 lg:px-16">
				{/* Container */}
				<div className="mx-auto max-w-5xl bg-white rounded-2xl shadow-md p-6 sm:p-10">

					{/* Title */}
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
						Shipping Policy
					</h1>

					{/* Breadcrumb */}
					<p className="text-sm text-gray-500 mb-8">
						<Link
							to="/"
							className="hover:text-blue-600 transition-colors"
						>
							Home
						</Link>
						<span className="mx-1">/</span>
						<span className="text-gray-700">Shipping Policy</span>
					</p>

					{/* Content */}
					<div className="space-y-5 text-gray-700 text-sm sm:text-base leading-relaxed">
						<p>
							The orders for the user are shipped through registered domestic courier
							companies and/or speed post only.
						</p>

						<p>
							Orders are shipped within <span className="font-semibold">1 day</span>{" "}
							from the date of the order and/or payment or as per the delivery date
							agreed at the time of order confirmation and delivery of the shipment,
							subject to courier company or post office norms.
						</p>

						<p>
							The Platform Owner shall not be liable for any delay in delivery by the
							courier company or postal authority.
						</p>

						<p>
							Delivery of all orders will be made to the address provided by the buyer
							at the time of purchase.
						</p>

						<p>
							Delivery of our services will be confirmed on your registered email ID
							as specified at the time of registration.
						</p>

						<p>
							If there are any shipping cost(s) levied by the seller or the Platform
							Owner (as the case may be), the same is{" "}
							<span className="font-semibold text-red-500">non-refundable</span>.
						</p>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ShippingPolicy;
